import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import md5 from 'md5';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            linkaff: "",
            point: 0,
            historylist: 0,
            useradvice: [],
            balance: 0,
            loginstate: null,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            username: "",
            tabselect: 1,
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            name: "",
            password: "",
            left: false,
        }
           this.copyCode = this.copyCode.bind(this);
    }
    logout = (e) => {

        // window.location.href = '/logout';

    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);

        var token = localStorage.getItem('auth_token');
        if (token) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliaminvite", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await Swal.fire({
                        title: 'Success!',
                        text: 'ทำรายการรับเงินเรียบร้อย',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    })

                }
                else if (res.data.status === 201) {
                    await Swal.fire({
                        title: 'error!',
                        text: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    })
                    return false;
                }
                else if (res.data.status === 202) {
                    await Swal.fire({
                        title: 'error!',
                        text: 'ไม่สามารถทำรายการได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    })
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        else {
            await Swal.fire({
                title: 'error!',
                text: 'กรุณาลีอคอิน',
                icon: 'error',
                confirmButtonText: 'ตกลง'
            })
            return false;
        }
    }
    checktab(e, index) {
        //console.log(index == 2 &&  this.state.qrcode != null);

        this.setState({
            tabselect: index,
        });


    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    copyCode = (text) => {
        console.log(text, "copyCode");
        navigator.clipboard
            .writeText(text)
            .then(() => {
                this.notify("warning", 'CopyCode!!!');
            })
            .catch((err) => {
                // console.log(err.message);
            });

    };
    async componentDidMount() {
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        var userAgent = navigator.userAgent.toLowerCase()
        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
                this.checkuseradvice(decoded.message.playerid);

            }
            else {
                this.setState({
                    loginstate: false,
                });
            }

        }
        catch (error) {
            //////console.log();
        }

    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice(username) {


        instance.post("/api/v1/checkuseradvice", {
            User_id: username,
            page: 1,
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                console.log(res.data.message.useradvicelist);
                this.setState({
                    useradvice: res.data.message.useradvicelist
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }

    cancelredeempromotion = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/usercancelpromotion", {
                        User_id: Username,
                        System: Systems,
                        no: index.no,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.checkpro(null, 999);
                            Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
                        }
                        else {
                            Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
                        }
                    });

                }
            })
        }

    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                //console.log(res.data)
                // console.log(res.data.message.tblpromotionredeems)
                if (res.data.type === 0) {
                    this.setState({
                        prodetail: res.data.message.tblpromotions,
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        proderedeemlist: res.data.message.tblpromotionredeems,
                    });

                }

            }
            else if (res.data.status === 201) {
                await Swal.fire({
                    title: 'error!',
                    text: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                })
                return false;
            }
            else if (res.data.status === 202) {
                await Swal.fire({
                    title: 'error!',
                    text: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                })
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                    icon: 'warning',
                    confirmButtonText: 'ตกลง'
                })
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        console.log(1, "validateLogout")
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //  this.rechecklogin(Username, token);
        this.setState({
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            //  console.log(5);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                    var i, tablinks;
                    tablinks = document.getElementsByClassName("-btn-balance");
                    for (i = 0; i < tablinks.length; i++) {
                        tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
                    }
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    //   console.log(res.data);
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                //    console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }
    }
    async calllisthistory(userid) {
        await instance.post("/api/v1/userwithdrawlist", {
            userid: userid,
            Cat_ID: 0,
            System: Systems,
            page: 1,
            type: 1
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                //  //console.log(datas.withdrawlist);
                this.setState({
                    historylist: datas.withdrawlist
                });

            }
            else {
                // this.CheckThisGoalError();
            }
        });

    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }


    render() {


        const { loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state

        //console.log(prodetail.length)
        return (
            <>
                <div className="x-invitation-index-container">
                    <div className="x-cover-invitation-container -has-container">
                        <div className="container">
                            <div
                                className="-cover-invitation-wrapper x-bg-position-center lazyloaded"
                                data-bgset="/build/web/igame-index-lobby-wm/img/invitation-cover-bg-dark.jpg?v=2"
                                style={{
                                    backgroundImage:
                                        'url("/build/web/igame-index-lobby-wm/img/invitation-cover-bg-dark.jpg?v=2")'
                                }}
                            >
                                <div className="-content-wrapper">
                                    <h1 className="-title">ลิงก์รับทรัพย์</h1>
                                    <p className="-sub-title">
                                        รับคอมมิชชั่นสูงถึง <span className="-highlight">3%</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="-invitation-info-wrapper">
                        <div className="container">
                            <div className="x-invitation-info">
                                <h2 className="-title">แนะนำเพื่อน</h2>
                                <div className="-invitation-link-info-wrapper">
                                    <div className="-deposit-required">
                                        {this.state.historylist.length > 0 ? (
                                            <span>
                                                ** กรุณา <b className="-highlight">ฝากเงิน</b>{" "}
                                                เพื่อเปิดระบบชวนเพื่อน และรับลิงก์ของท่าน **
                                            </span>
                                        ) : (
                                            <>
                                                กดที่ลิงค์ <span className="-highlight">
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault(); // กันไม่ให้ jump ไปหน้าอื่น
                                                            this.copyCode(linkaff);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                        className="-copy-wrapper js-copy-to-clipboard"
                                                        data-container="shareAccountProfileBankInfo"
                                                        data-message="คัดลอกแล้ว!"
                                                    >
                                                        {linkaff}
                                                    </a>
                                                </span>
                                            </>
                                        )}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="-info-panel-wrapper">
                        <div className="container">
                            <div className="x-invitation-base x-invitation-overview-panel">
                                <div className="x-invitation-menu-wrapper">
                                    <a
                                        onClick={(e) => this.checktab(e, 1)}
                                        role="button"
                                        className={`btn -btn-menu ${this.state.tabselect === 1 ? '-active' : ''}`}>
                                        ภาพรวม
                                    </a>

                                    <a
                                        onClick={(e) => this.checktab(e, 2)}
                                        role="button"
                                        className={`btn -btn-menu ${this.state.tabselect === 2 ? '-active' : ''}`}>
                                        สรุปรายได้
                                    </a>

                                    <a
                                        onClick={(e) => this.checktab(e, 3)}
                                        role="button"
                                        className={`btn -btn-menu ${this.state.tabselect === 3 ? '-active' : ''}`}>
                                        สมาชิกทั้งหมด
                                    </a>

                                    <a
                                        onClick={(e) => this.checktab(e, 4)}
                                        role="button"
                                        className={`btn -btn-menu ${this.state.tabselect === 4 ? '-active' : ''}`}>
                                        ประวัติการโอนรายได้
                                    </a>
                                </div>
                                <div className="-content-outer-wrapper" style={{ display: this.state.tabselect == 1 ? "" : "none" }}>
                                    <div className="x-invitation-overview">
                                        <div className="-menu-list">
                                            <div className="-menu-list-item">
                                                <span className="-label">คลิกลิงก์ทั้งหมด</span>
                                                <span className="-value">0</span>
                                            </div>
                                            <div className="-menu-list-item">
                                                <span className="-label">ผู้สมัครทั้งหมด</span>
                                                <span className="-value">0</span>
                                            </div>
                                            <div className="-menu-list-item">
                                                <span className="-label">รายได้ทั้งหมด</span>
                                                <span className="-value">0.00</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="-heading-wrapper">
                                        <span className="-heading-title">ภาพรวม</span>
                                        <div className="x-invitation-filter -in-heading -summary">
                                            <div className="x-invitation-datepicker -range-mode">
                                                <div className="-main-btn-wrapper">
                                                    <i className="fas fa-calendar-alt" />
                                                    <input
                                                        type="text"
                                                        id="invitation_summary_date_filter"
                                                        name="invitation_summary_date_filter"
                                                        className="js-datepicker js-date-range-input form-control -form-control flatpickr-input"
                                                        data-mode="range"
                                                        data-max-date="today"
                                                        data-human-read="true"
                                                        data-url="https://aesexy.ai/invitation"
                                                        data-on-date-change="_onDateInvitationChange_"
                                                        placeholder="กรุณาเลือกวันที่"
                                                        defaultValue="2025-05-24"
                                                        readOnly="readonly"
                                                    />
                                                </div>
                                                <a
                                                    href="https://aesexy.ai/invitation"
                                                    className="btn -btn-clear d-none"
                                                >
                                                    เคลียร์
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="x-invitation-overview">
                                        <div className="-menu-list">
                                            <div className="-menu-list-item">
                                                <span className="-label">จำนวนคลิกลิ้งค์</span>
                                                <span className="-value">0</span>
                                            </div>
                                            <a
                                                href="/invitation/member?filterType=registered"
                                                className="-menu-list-item -has-link"
                                            >
                                                <i className="fas fa-external-link-alt -ic-link" />
                                                <span className="-label">จำนวนผู้สมัคร</span>
                                                <span className="-value">0</span>
                                            </a>
                                            <a
                                                href="/invitation/member?filterType=active"
                                                className="-menu-list-item -has-link"
                                            >
                                                <i className="fas fa-external-link-alt -ic-link" />
                                                <span className="-label">ผู้เล่นเคลื่อนไหว</span>
                                                <span className="-value">0</span>
                                            </a>
                                            <div className="-menu-list-item">
                                                <span className="-label">รายได้</span>
                                                <span className="-value">0.00</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="-table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover table-borderless x-invitation-table ">
                                                <thead>
                                                    <tr>
                                                        <th className=" text-center" width="50%">
                                                            ประเภทเกมส์
                                                        </th>
                                                        <th className=" text-center" width="50%">
                                                            รายได้
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody></tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="-content-outer-wrapper" style={{ display: this.state.tabselect == 2 ? "" : "none" }}>

                                    <div className="-heading-wrapper -zero-margin-top">
                                        <span className="-heading-title">สรุปรายได้ทั้งหมด</span>
                                    </div>
                                    <div className="x-invitation-overview">
                                        <div className="-menu-list">
                                            <div className="-menu-list-item">
                                                <span className="-label">คลิกลิงก์ทั้งหมด</span>
                                                <span className="-value">0</span>
                                            </div>
                                            <div className="-menu-list-item">
                                                <span className="-label">ผู้สมัครทั้งหมด</span>
                                                <span className="-value">0</span>
                                            </div>
                                            <div className="-menu-list-item">
                                                <span className="-label">รายได้ทั้งหมด</span>
                                                <span className="-value">0.00</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="-filter-wrapper">
                                        <div className="x-invitation-filter -income">
                                            <a
                                                href="/invitation/income?filterType=daily"
                                                className="btn -btn-filter -active"
                                            >
                                                รายวัน
                                            </a>
                                            <a
                                                href="/invitation/income?filterType=member"
                                                className="btn -btn-filter "
                                            >
                                                สมาชิก
                                            </a>
                                            <a href="/invitation/income?filterType=type" className="btn -btn-filter ">
                                                ประเภทเกม
                                            </a>
                                        </div>
                                    </div>
                                    <div className="-table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover table-borderless x-invitation-table ">
                                                <thead>
                                                    <tr>
                                                        <th className=" text-center" width="50%">
                                                            วันที่
                                                            <a
                                                                href="/invitation/income?criteria%5Bdate%5D=all&sorting%5Bdate%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                        <th className=" text-center" width="50%">
                                                            รายได้
                                                            <a
                                                                href="/invitation/income?criteria%5Bdate%5D=all&sorting%5Bincome%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody></tbody>
                                            </table>
                                        </div>
                                        <div className="-pagination-wrapper">
                                            <span className="-volume">0 รายการ</span>
                                        </div>
                                    </div>

                                </div>
                                <div className="-content-outer-wrapper" style={{ display: this.state.tabselect == 3 ? "" : "none" }}>

                                    <div className="-heading-wrapper -zero-margin">
                                        <span className="-heading-title">สมาชิกทั้งหมด</span>
                                        <div className="x-invitation-filter -filter-group -in-heading -zero-margin -member">
                                            <a href="/invitation/member" className="btn -btn-filter -main -active">
                                                ทั้งหมด
                                            </a>
                                            <a
                                                href="/invitation/member?filterType=registered"
                                                className="btn -btn-filter -main "
                                            >
                                                ระบุวัน
                                            </a>
                                        </div>
                                    </div>
                                    <div className="-table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover table-borderless x-invitation-table -table-xs">
                                                <thead>
                                                    <tr>
                                                        <th className=" text-center" width="20%">
                                                            เบอร์โทรศัพท์
                                                        </th>
                                                        <th className=" text-center" width="23%">
                                                            วันสมัคร
                                                            <a
                                                                href="/invitation/member?sorting%5BcreatedAt%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                        <th className=" text-center" width="32%">
                                                            เคลื่อนไหวล่าสุด
                                                            <a
                                                                href="/invitation/member?sorting%5BactiveAt%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                        <th className=" text-center" width="25%">
                                                            รายได้
                                                            <a
                                                                href="/invitation/member?sorting%5BgiveIncome%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody></tbody>
                                            </table>
                                        </div>
                                        <div className="-pagination-wrapper">
                                            <span className="-volume">0 รายการ</span>
                                        </div>
                                    </div>



                                </div>
                                <div className="-content-outer-wrapper" style={{ display: this.state.tabselect == 4 ? "" : "none" }}>

                                    <div className="-heading-wrapper -zero-margin">
                                        <span className="-heading-title">ประวัติการโอนรายได้</span>
                                    </div>
                                    <div className="-table-wrapper">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover table-borderless x-invitation-table ">
                                                <thead>
                                                    <tr>
                                                        <th className=" text-center" width="">
                                                            วันเวลาทำรายการ
                                                            <a
                                                                href="/invitation/history?sorting%5BcreatedAt%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                        <th className=" text-center" width="">
                                                            ยอดโอน
                                                            <a
                                                                href="/invitation/history?sorting%5Bamount%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                        <th className=" text-center" width="">
                                                            หมายเหตุ
                                                        </th>
                                                        <th className=" text-center" width="">
                                                            สถานะ
                                                            <a
                                                                href="/invitation/history?sorting%5Bstate%5D=asc"
                                                                className="-btn-sortable"
                                                            >
                                                                <i className="fas fa-sort-amount-down" />
                                                            </a>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody></tbody>
                                            </table>
                                        </div>
                                        <div className="-pagination-wrapper">
                                            <span className="-volume">0 รายการ</span>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="-content-section-wrapper">
                        <div className="container">
                            <div className="x-invitation-content-section-container">
                                <div className="-title-wrapper">
                                    <span className="-title">รับเงินได้ทุกวัน</span>{" "}
                                    <span className="-title -xl ml-2">Passive Income ที่แท้จริง</span>
                                </div>
                                <div className="-image-wrapper">
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet="/build/web/igame-index-lobby-wm/img/invitation-content-section-1-dark.webp?v=2"
                                        />
                                        <source
                                            type="image/jpg?v=2"
                                            srcSet="/build/web/igame-index-lobby-wm/img/invitation-content-section-1-dark.jpg?v=2"
                                        />
                                        <img
                                            alt="เริ่มต้นง่ายๆ ได้ทุกการเล่น"
                                            className="img-fluid -image"
                                            width={1110}
                                            height={329}
                                            src="/build/web/igame-index-lobby-wm/img/invitation-content-section-1-dark.jpg?v=2"
                                        />
                                    </picture>
                                </div>
                                <div className="-title-wrapper">
                                    <span className="-title">ทำมาแล้ว!</span>
                                    <br />{" "}
                                    <span className="-title -lg">แค่เพื่อนเล่น เราก็รับทรัพย์</span>
                                    <br /> <span className="-title -lg">รายได้ 6 หลัก</span>{" "}
                                    <span className="-title -lg ml-1 -underline">ง่ายๆ ทุกเดือน</span>
                                </div>
                                <div className="-image-wrapper">
                                    <picture>
                                        <source
                                            type="image/webp"
                                            srcSet="/build/web/igame-index-lobby-wm/img/invitation-content-section-2-dark.webp?v=2"
                                        />
                                        <source
                                            type="image/jpg?v=2"
                                            srcSet="/build/web/igame-index-lobby-wm/img/invitation-content-section-2-dark.jpg?v=2"
                                        />
                                        <img
                                            alt="เริ่มต้นง่ายๆ ได้ทุกการเล่น"
                                            className="img-fluid -image"
                                            width={1110}
                                            height={329}
                                            src="/build/web/igame-index-lobby-wm/img/invitation-content-section-2-dark.jpg?v=2"
                                        />
                                    </picture>
                                </div>
                                <div className="-title-wrapper">
                                    <span className="-title">แนะนำเพื่อนกับเราดียังไง</span>
                                </div>
                                <div className="-content-wrapper">
                                    <h3 className="-title">
                                        ง่ายกว่าที่คุณคิด เพียงคัดลอกลิงก์ของคุณ ส่งให้เพื่อน ยิ่งชวน
                                        ยิ่งได้ มีรายได้ทุกวัน
                                    </h3>{" "}
                                    <p className="-description">
                                        ส่วนแบ่งจากการแนะนำ สามารถนำไปเดิมพันต่อ หรือ ถอนได้เลย
                                        ไม่มีเทิร์นโอเวอร์ ไม่จำกัดยอด สร้างรายได้กับเราได้ทันที ชวนเลย
                                        เพื่อนสายบาคาร่า เพื่อนสายสล็อต เพื่อนสายกีฬา เพื่อนสายยิงปลา
                                        เพื่อนสายหวย ไม่ว่าสายไหนก็ชวนเพื่อนได้ไม่จำกัด
                                        รับส่วนแบ่งค่าคอมมิชชั่นแบบเน้นๆ จ่ายกันแบบรายวัน
                                        อัพเดทยอดของเพื่อนคุณแบบเรียลไทม์ แค่เพื่อนเล่น
                                        คุณก็มีรายได้ไม่จำกัด
                                    </p>
                                </div>
                                <div className="x-invitation-percent-and-condition-component">
                                    <div className="-title-wrapper">
                                        <strong className="-title">เงื่อนไขและเปอร์เซ็นต์</strong>
                                    </div>
                                    <ul className="navbar-nav -percent-list">
                                        <li className="nav-item -percent-list-item">
                                            <strong className="-topic">คาสิโน</strong>
                                            <p className="-percent">0.3%</p>
                                            <span className="-description">สูงสุด 5000 /วัน</span>
                                        </li>
                                        <li className="nav-item -percent-list-item">
                                            <strong className="-topic">สล็อต</strong>
                                            <p className="-percent">0.5%</p>
                                            <span className="-description">สูงสุด 5000 /วัน</span>
                                        </li>
                                        <li className="nav-item -percent-list-item">
                                            <strong className="-topic">หวย</strong>
                                            <p className="-percent">3%</p>
                                            <span className="-description">สูงสุด 5000 /วัน</span>
                                        </li>
                                        <li className="nav-item -percent-list-item">
                                            <strong className="-topic">1234 คริปโต</strong>
                                            <p className="-percent">0.3%</p>
                                            <span className="-description">สูงสุด 5000 /วัน</span>
                                        </li>
                                        <li className="nav-item -percent-list-item">
                                            <strong className="-topic">กีฬา</strong>
                                            <p className="-percent">1%</p>
                                            <span className="-description">สูงสุด 2000 /วัน</span>
                                        </li>
                                    </ul>
                                    <div className="-user-description">
                                        <div className="-content-wrapper">
                                            <div className="text-muted mb-3">
                                                *เปอร์เซนต์คิดจาก <b>"Turnover"</b> ของสมาชิกคุณ{" "}
                                                <u className="text-danger">ยกเว้นประเภทกีฬา</u> จะคิดจาก{" "}
                                                <b>"ยอดได้"</b>
                                            </div>
                                            <h3 className="-title">
                                                ตัวอย่างการได้ค่าเเนะนำแนะนำเพื่อนเล่นหวย
                                            </h3>
                                            <p className="-description">
                                                สมาชิกของคุณ 1 คน เดิมพันหวย 1,000 เครดิต คุณจะได้รับรายได้ 30
                                                เครดิต <br />
                                                สมาชิกของคุณ 10 คน เดิมพันหวย 1,000 เครดิต คุณจะได้รับรายได้
                                                300 เครดิต <br />
                                                สมาชิกของคุณ 100 คน เดิมพันหวย 1,000 เครดิต คุณจะได้รับรายได้
                                                3,000 เครดิต <br />
                                            </p>
                                            <h3 className="-title">แนะนำเพื่อนเล่นคาสิโน</h3>
                                            <p className="-description">
                                                สมาชิกของคุณ 1 คน เดิมพันคาสิโน 1,000 เครดิต คุณจะได้รับรายได้
                                                3 เครดิต <br />
                                                สมาชิกของคุณ 10 คน เดิมพันคาสิโน 1,000 เครดิต
                                                คุณจะได้รับรายได้ 30 เครดิต <br />
                                                สมาชิกของคุณ 100 คน เดิมพันคาสิโน 1,000 เครดิต
                                                คุณจะได้รับรายได้ 300 เครดิต <br />
                                            </p>
                                            <h3 className="-title">แนะนำเพื่อนเล่นกีฬา</h3>
                                            <p className="-description">
                                                สมาชิกของคุณ 1 คน มียอดได้จากกีฬา 1,000 เครดิต
                                                คุณจะได้รับรายได้ 10 เครดิต <br />
                                                สมาชิกของคุณ 10 คน มียอดได้จากกีฬา 1,000 เครดิต
                                                คุณจะได้รับรายได้ 100 เครดิต <br />
                                                สมาชิกของคุณ 100 คน มียอดได้จากกีฬา 1,000 เครดิต
                                                คุณจะได้รับรายได้ 1,000 เครดิต <br />
                                            </p>
                                            <h3 className="-title">เงื่อนไขการถอนเครดิตเเนะนำเพื่อน</h3>
                                            <p className="-description">
                                                ต้องมีรายการฝากเงิน 1 ครั้งขึ้นไป
                                                ภายในเดือนที่แจ้งถอนเครดิตแนะนำเพื่อน <br />
                                            </p>
                                            <em className="f-7">
                                                ** หากพบว่ามีการทุจริตในการปั้มค่าคอมมิชชั่น เดิมพันผิดปกติ
                                                และ ล่าโปรโมชั่น มีมากกว่า 1 ยูส หรืออื่นๆ
                                                ที่เข้าข่ายการฉ้อโกงทางบริษัทจะทำการระงับการจ่ายค่าคอมโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                                            </em>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
}
export default App;
